<template>
  <div id="contenedor-cambiar-correo-usuario">
    <v-form
    v-model="formularioValido"
    ref="cambiarCorreoUsuario">
      <v-card>
        <v-card-title class="secondary--text">
          Actualizar Correo de Usuario
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            cols="12"
            v-model="usuario.correoElectronico"
            label="Nuevo Correo Electrónico"
            :rules="[mixReglas.requerido]">
          </custom-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarUsuarioBasico"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoUsuarios from './mixCatalogoUsuarios';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CambiarCorreoUsuario',
  mixins: [mixCatalogoUsuarios],
  props: {
    usuarioId: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      usuario: {
        correoElectronico: '',
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.cambiarCorreoUsuario.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },

};
</script>

<style>

</style>
